import { createFileRoute } from '@tanstack/react-router';
import { ReportsInboxPage } from '@/features/people/pages/reports-inbox-page';

export const Route = createFileRoute('/_app/reports-inbox')({ component: ReportsInboxPage });
